var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCleverbaseAppIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "#371F13"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.669 98.1863C112.737 98.8675 112.771 99.736 112.771 100.792C112.771 101.814 112.703 103.006 112.567 104.368C112.465 105.696 112.328 106.991 112.158 108.251C111.715 111.112 111.273 113.156 110.83 114.382C103.541 118.026 94.0724 119.848 82.424 119.848C71.5248 119.848 62.2265 116.97 54.529 111.214C48.9091 107.025 44.9752 101.149 42.7273 93.5882C41.5693 89.7054 40.9902 84.9881 40.9902 79.4364C40.9902 73.8506 42.0631 68.5884 44.2089 63.6497C46.3546 58.677 49.3519 54.4535 53.2007 50.9794C61.2047 43.7588 71.5929 40.1484 84.3654 40.1484C86.7495 40.1484 89.866 40.3698 93.7148 40.8126C97.5635 41.2554 100.084 41.5279 101.276 41.63L104.75 41.9877C107.373 42.2261 109.093 42.3453 109.91 42.3453H111.545C111.783 42.3453 112.158 42.3112 112.669 42.2431C112.737 43.0605 112.771 44.9849 112.771 48.0162C112.771 51.0476 112.226 56.1395 111.136 63.2921H104.597C103.95 58.149 103.132 54.5898 102.145 52.6143C99.3176 48.0844 93.1358 45.8194 83.599 45.8194C74.0623 45.8194 66.6202 48.9529 61.2728 55.2199C56.1639 61.1804 53.6094 69.0652 53.6094 78.8744C53.6094 90.2163 56.811 99.0889 63.2142 105.492C69.0725 111.35 76.2251 114.28 84.6719 114.28C90.7686 114.28 95.4007 113.122 98.5683 110.805C101.77 108.455 104.341 104.249 106.283 98.1863H112.669Z",
    fill: "#FAF5EB"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCleverbaseAppIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cleverbase-app-icon.676105ab14196f4a44b3f49d8e82db64.svg";